import type { IApplicationInfo } from '~/types/application-info'

import config from '~/config'
import { request } from '~/utils/request'

export const listApplicationsInfo = (clientId: string, appKey?: string): Promise<IApplicationInfo[]> => {
  return request({
    params: {
      appKey,
    },
    url: `${config.ACCOUNT_API}/clients/${clientId}/apps`,
  })
}
